/**
 * product-card-standard.js
 * Handles the variant image slider (.pcs-slider) on all product cards.
 * Works with product-card-standard, new-launches, and product-list cards.
 *
 * The slider is always inside a wrapper with position:relative.
 * The card root is the closest ancestor with data-selected-variant OR
 * data-product-id attribute.
 */

(function () {
  'use strict';

  function findCardRoot(slider) {
    // Walk up to find the card container
    var el = slider.parentElement;
    while (el) {
      if (
        el.hasAttribute('data-selected-variant') ||
        el.hasAttribute('data-product-id')
      ) {
        return el;
      }
      el = el.parentElement;
    }
    return slider.closest('.product-card-standard, .product-card, .pl-card') || slider.parentElement;
  }

  function normalizeCurrencyText(value) {
    if (!value) return value;
    if (window.__baybeeNormalizeCurrencyText) {
      return window.__baybeeNormalizeCurrencyText(value);
    }
    return String(value).replace(/Rs\.?\s*/g, '₹ ').replace(/INR\s*/g, '₹ ');
  }

  function initSlider(slider) {
    if (slider._pcsInit) return;
    slider._pcsInit = true;

    var slides   = Array.from(slider.querySelectorAll('.pcs-slider__slide'));
    var prevBtn  = slider.querySelector('.pcs-slider__arrow--prev');
    var nextBtn  = slider.querySelector('.pcs-slider__arrow--next');

    if (!slides.length) return;

    var card = findCardRoot(slider);

    // Selectors that work across all card types
    var variantInput = card.querySelector('.product-card-standard__variant-id');
    var addBtn       = card.querySelector('.product-card-standard__add-btn, .add-to-cart, .pl-card__atc');
    var mainImage    = card.querySelector('.product-card-standard__main-image, .nl-main-image, .pl-card__main-image');
    var currentPrice = card.querySelector('.product-card-standard__current-price, .nl-current-price, .pl-card__price-current');
    var comparePrice = card.querySelector('.product-card-standard__compare-price, .nl-compare-price, .pl-card__price-compare');
    var wishlistBtn  = card.querySelector('.product-card-standard__wishlist-container, [data-wlh-variantid]');

    var current = parseInt(slider.getAttribute('data-current'), 10) || 0;

    function applyVariant(slide) {
      var variantId = slide.getAttribute('data-variant-id');
      var available = slide.getAttribute('data-variant-available') === 'true';
      var price     = normalizeCurrencyText(slide.getAttribute('data-variant-price'));
      var compareAt = normalizeCurrencyText(slide.getAttribute('data-variant-compare-price'));
      var imageSrc  = slide.getAttribute('data-variant-image');

      if (variantInput) variantInput.value = variantId;

      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }

      if (mainImage && imageSrc) mainImage.src = imageSrc;

      if (currentPrice && price) currentPrice.textContent = price;
      if (comparePrice) {
        if (compareAt) {
          comparePrice.textContent = compareAt;
          comparePrice.style.display = '';
        } else {
          comparePrice.style.display = 'none';
        }
      }

      if (wishlistBtn) wishlistBtn.setAttribute('data-wlh-variantid', variantId);
      if (card) card.setAttribute('data-selected-variant', variantId);
    }

    function goTo(index) {
      if (index < 0) index = 0;
      if (index >= slides.length) index = slides.length - 1;

      slides[current].classList.remove('is-active');
      current = index;
      slider.setAttribute('data-current', current);
      slides[current].classList.add('is-active');

      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current === slides.length - 1;

      applyVariant(slides[current]);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(current - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(current + 1);
      });
    }

    slides.forEach(function (slide, i) {
      slide.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(i);
      });
    });

    if (prevBtn) prevBtn.disabled = current === 0;
    if (nextBtn) nextBtn.disabled = current === slides.length - 1;
  }

  function initAllSliders(root) {
    var sliders = (root || document).querySelectorAll('.pcs-slider');
    sliders.forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAllSliders(); });
  } else {
    initAllSliders();
  }

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('pcs-slider')) {
            initSlider(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('.pcs-slider').forEach(initSlider);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
